import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileProjects = ({ isDarkMode }) => {
    const [projectsData, setProjectsData] = useState([]);

    useEffect(() => {
        fetch('/data/projects.json')
            .then(response => response.json())
            .then(data => {
                const sortedProjects = [...data].sort((a, b) => b.id - a.id);
                setProjectsData(sortedProjects);
            })
            .catch(error => console.error('Error fetching projects data:', error));
    }, []);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Projects</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {projectsData.map((project, index) => (
                        <div key={index} className="mobile-card mobile-project-card">
                            {project.image && (
                                <div className="mobile-project-image-container">
                                    <img
                                        src={project.image}
                                        alt={project.title}
                                        className="mobile-project-image"
                                    />
                                </div>
                            )}
                            <div className="mobile-project-content">
                                <h3 className="mobile-card-title">{project.title}</h3>
                                <p className="mobile-card-description">{project.description}</p>
                                {project.technologies && project.technologies.length > 0 && (
                                    <div className="mobile-tech-list">
                                        {project.technologies.map((tech, techIndex) => (
                                            <span key={techIndex} className="mobile-tech-item">{tech}</span>
                                        ))}
                                    </div>
                                )}
                                {(project.demo || project.github) && (
                                    <a
                                        href={project.demo || project.github}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mobile-project-link"
                                    >
                                        <i className={project.demo ? "fa-solid fa-arrow-up-right-from-square" : "fa-brands fa-github"}></i>
                                        {project.demo ? "View Demo" : "View GitHub"} →
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}

                    <div className="mobile-footer-note">
                        <p>
                            The projects above are merely a curated highlight reel of my escapades. To shield you
                            from the perils of boredom and infinite scrolling, I've spotlighted only those works,
                            where my contributions were significant, not just a simple patch fix or README update.
                        </p>
                        <p>
                            Beyond this, I've contributed to a smorgasbord of college websites and portals, plus a
                            forgotten attic of personal projects that either fizzled out or got eclipsed by life's
                            more pressing plot twists.
                        </p>
                        <p>
                            For the unabridged saga, swing by my GitHub. But let's face it, you've probably got a life
                            to live and won't even make it this far. So, cheers! :)
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileProjects;
